module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAbFBMVEUAUboDU7sGVbwKWL0OW74hWzMpbcUtcMY1dck5eMk6ecpDc45Nhs9QiNBVi9Fbeytbj9NekdNilNVol9Z/qNybu+SeveWmwufBsz3JtR3O3vLP3vLP3/LQ3/LY5PTe6Pbt8/rw9fv80Rb+/v9CnfESAAAAlUlEQVR42oXPNxLDMAxE0SWtYMnK0VGJ97+jMYMC1Q4/iy3wGkK6Azqsx/O6gGzceg/4fhszyl4t4L6hg9SFn6MsTQFMTQ2pbibOBGpFAXBmcDiOgTOF2nlyZvCGpCwTGcoUulmPs2NMYb6HxQN+CXtOmEKsnwpS9V4pU5jI06FMIj/l0BgpwizCCDTGMxbJWAwqi/cH9nYVhpePzfgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sb.png
// module id = 915
// module chunks = 0